import React, { useState, useContext } from "react";
import { i18n } from "../../translate/i18n";
import { 
    Avatar, 
    CardHeader, 
    Grid,
    Dialog,
    DialogContent,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { AuthContext } from "../../context/Auth/AuthContext";

const useStyles = makeStyles((theme) => ({
    // Estilos para o modal da imagem
    imageModal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    imageModalContent: {
        outline: "none",
        maxWidth: "90vw",
        maxHeight: "90vh",
    },
    expandedImage: {
        width: "100%",
        height: "auto",
        maxWidth: "500px",
        borderRadius: theme.spacing(1),
    },
    clickableAvatar: {
        cursor: "pointer",
        "&:hover": {
            opacity: 0.8,
        },
    },
    // #4210: o nome era cortado em 12 caracteres no código (substring), então
    // "Maria Aparecida" virava "Maria Aparec...". Agora vai inteiro e quebra
    // linha quando não cabe — com teto de 2 linhas para o cabeçalho não crescer
    // sem limite e empurrar os botões de ação (nome muito longo ainda ganha "…"
    // na 2ª linha, via line-clamp).
    contactName: {
        whiteSpace: "normal",
        overflowWrap: "anywhere",
        display: "-webkit-box",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
    }
}));

const presenceLabel = (state) => {
    if (state === "composing") return "digitando…";
    if (state === "recording") return "gravando áudio…";
    if (state === "available") return "online";
    return null;
};

const TicketInfo = ({ contact, ticket, presence, onClick }) => {
    const classes = useStyles();
    const [amount, setAmount] = useState("");
    const { user } = useContext(AuthContext);
    const [imageModalOpen, setImageModalOpen] = useState(false); // Estado para o modal da imagem

    // Função para abrir modal da imagem
    const handleImageClick = (e) => {
        e.stopPropagation(); // Prevenir que o clique no avatar execute outros handlers
        if (contact?.urlPicture) {
            setImageModalOpen(true);
        }
    };

    // Função para fechar modal da imagem
    const handleImageModalClose = () => {
        setImageModalOpen(false);
    };

    const renderCardReader = () => {
        return (
            <CardHeader
                onClick={onClick}
                style={{ cursor: "pointer" }}
                titleTypographyProps={{ className: classes.contactName }}
                avatar={
                    <Avatar
                        src={contact?.urlPicture}
                        alt="contact_image"
                        className={classes.clickableAvatar}
                        onClick={handleImageClick}
                    />
                }
                title={`${contact?.name || '(sem contato)'} #${ticket?.id}`}
                subheader={
                    presenceLabel(presence)
                        ? presenceLabel(presence)
                        : [
                            ticket?.user && `${i18n.t("messagesList.header.assignedTo")} ${ticket?.user?.name}`,
                            contact?.contactWallets && contact.contactWallets.length > 0
                                ? `• ${i18n.t("wallets.wallet")}: ${contact.contactWallets[0].wallet?.name || 'N/A'}`
                                : null
                        ].filter(Boolean).join(' ')
                }
                subheaderTypographyProps={presenceLabel(presence)
                    ? { noWrap: true, style: { color: "#25d366", fontWeight: 600 } }
                    : { noWrap: true }}
            />
        );
    }

    const handleChange = (event) => {
        const value = event.target.value;
        setAmount(value);
    }

    return (
        <React.Fragment>
            {/* #4210: era xs={6} + spacing={10}, cortando o cabeçalho pela metade
                da largura sem nada ocupando a outra metade — o nome tinha pouco
                espaço mesmo depois de remover o truncamento. Largura total. */}
            <Grid container alignItems="center">
                <Grid item xs={12}>
                    {renderCardReader()}
                </Grid>
            </Grid>

            {/* Modal da Imagem */}
            <Dialog
                open={imageModalOpen}
                onClose={handleImageModalClose}
                className={classes.imageModal}
                maxWidth="md"
                fullWidth
            >
                <DialogContent className={classes.imageModalContent}>
                    <img 
                        src={contact?.urlPicture} 
                        alt={contact?.name || "Foto do contato"}
                        className={classes.expandedImage}
                    />
                </DialogContent>
            </Dialog>
        </React.Fragment>
    );
};

export default TicketInfo;